import { ModelInitialState } from '@/modules/settings/brands/types/types.ts'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState: ModelInitialState = {
  openCreateModal: false,
  selected: null,
  isDeleteModalOpen: false,
  isAssociateModelsModalOpen: false
}

const modelSlice = createSlice({
  name: 'models',
  initialState,
  reducers: {
    selectModel(state, action) {
      state.selected = action.payload
    },
    cleanSelection(state) {
      state.selected = null
    },
    openModal: (state) => {
      state.openCreateModal = true
    },
    closeModal: (state) => {
      state.openCreateModal = false
    },
    setDeleteOpenModal: (state, action: PayloadAction<boolean>) => {
      state.isDeleteModalOpen = action.payload
    },
    setAssociateModelsModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isAssociateModelsModalOpen = action.payload
    }
  }
})

export const modelActions = modelSlice.actions

export const { reducer: modelReducer } = modelSlice
